import { render, staticRenderFns } from "./MarkdownInput.vue?vue&type=template&id=33c50815&scoped=true&"
import script from "./MarkdownInput.vue?vue&type=script&lang=js&"
export * from "./MarkdownInput.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownInput.vue?vue&type=style&index=0&id=33c50815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c50815",
  null
  
)

export default component.exports